import OrganizationUserNew from 'src/components/Organization/pages/users/new';

export default OrganizationUserNew;
